var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.68137C22 9.07555 22 8.77265 21.8802 8.63238C21.7763 8.51068 21.6203 8.44609 21.4608 8.45865C21.2769 8.47312 21.0627 8.68731 20.6343 9.11569L17 12.75L20.6343 16.3843C21.0627 16.8127 21.2769 17.0269 21.4608 17.0414C21.6203 17.0539 21.7763 16.9893 21.8802 16.8676C22 16.7274 22 16.4244 22 15.8186V9.68137Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.55C2 8.86984 2 8.02976 2.32698 7.38803C2.6146 6.82354 3.07354 6.3646 3.63803 6.07698C4.27976 5.75 5.11984 5.75 6.8 5.75H12.2C13.8802 5.75 14.7202 5.75 15.362 6.07698C15.9265 6.3646 16.3854 6.82354 16.673 7.38803C17 8.02976 17 8.86984 17 10.55V14.95C17 16.6302 17 17.4702 16.673 18.112C16.3854 18.6765 15.9265 19.1354 15.362 19.423C14.7202 19.75 13.8802 19.75 12.2 19.75H6.8C5.11984 19.75 4.27976 19.75 3.63803 19.423C3.07354 19.1354 2.6146 18.6765 2.32698 18.112C2 17.4702 2 16.6302 2 14.95V10.55Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.4fe79c1ba6206d9d6f11d994b8f9a317.svg";
export { ForwardRef as ReactComponent };